import ExternalFeedRoutes from "./ExternalFeedRoutes";

export default ExternalFeedRoutes;
